import * as React from 'react';
import { HashRouter, Route, Switch, Redirect } from 'react-router-dom';
// for cross browser support
import "babel-polyfill";

import './index.css';

import Dashboard from './dashboard';
import reports from './components/Subscription/subscriptionReports';
import productionReports from './components/Production/productionReports';
import productionSpeed from './components/Production Speed/productionSpeed';
import enclosurePO from './components/Enclosure PO/enclosurePO';
import all41Projects from './components/All 4.1 Projects/all41Projects';
import openModsReport from './components/Open Mods/openModsReport';
import { PrivateRoute } from './sharedcomponents/privateRoute';

class App extends React.Component<any, any> {
    public render() {
        return (
            <HashRouter>
                <Switch>
                    <Route exact={true} path={"/login"} render={(props) => {
                        const expiryDate = new Date();
                        expiryDate.setDate(expiryDate.getDate() + 10000);
                        const atlasForm = {
                            session: {
                                session_expires_at: expiryDate.toString(),
                                session_key: 'AE39o8OtX83SzJf_EsK3zzqRMofaPCFZ10KrlZcT3UmrwtqyDt4d48ZBBH2w='
                            },
                        };
                        window.localStorage.setItem("ReportsUserInfo", JSON.stringify(atlasForm))
                        return (
                            <Redirect to={{ pathname: '/dashboard/', state: { from: props.location } }} />
                        )
                    }} />

                    <Route exact={true} path={"/"} render={props => (<Redirect to={{ pathname: '/login', state: { from: props.location } }} />)} />
                    <Route exact={true} path={"/from-atlas/"} render={props => (<Redirect to={{ pathname: '/login', state: { from: props.location } }} />)} />

                    <PrivateRoute exact={true} path="/dashboard/" component={Dashboard} />
                    <PrivateRoute path="/subscriptionReports" component={reports} />
                    <PrivateRoute path="/productionReports" component={productionReports} />
                    <PrivateRoute path="/productionSpeed" component={productionSpeed} />
                    <PrivateRoute path="/enclosurePO" component={enclosurePO} />
                    <PrivateRoute path="/all41Projects" component={all41Projects} />
                    <PrivateRoute path="/openModsReport" component={openModsReport} />
                </Switch>
            </HashRouter>
        )
    }
}
export default App;


// WEBPACK FOOTER //
// ./src/app.tsx